import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-initiatives-hero',
  templateUrl: './initiatives-hero.component.html',
  styleUrls: ['./initiatives-hero.component.css']
})
export class InitiativesHeroComponent
{
  @Input({ required: true }) public title!: string;
  @Input({ required: true }) public backgroundClass!: string;
  @Input({ required: true }) public textClass!: string;
  @Input({ required: true }) public imgBannerUrl!: string;
  @Input({ required: true }) public altImgBanner!: string;
  @Input() public subtitle?: string;
}
